<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-3">
        <search-dips
          @listenTransferNumber="listenTransferNumber"
          class="search"
        />
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col">
            <!-- <button
              class="btn btn-danger btn-actions"
              data-bs-toggle="modal"
              data-bs-target="#deleteMultiDipsModal"
              :disabled="buttonDisabled"
            >
              Delete Selected DIPs
            </button> -->
            <button
              class="btn btn-success btn-actions"
              data-bs-toggle="modal"
              data-bs-target="#downloadMultiDipsModal"
              :disabled="buttonDisabled"
            >
              Download Selected DIPs
            </button>
          </div>
        </div>
        <div>
          <vue-good-table
            class="vue-table"
            :columns="columns"
            :rows="currentDip"
            :key="tableKey"
            :isLoading.sync="isLoading"
            styleClass="vgt-table condensed bordered"
            @selected-rows-change="selectionChanged"
            @row-click="onRowClick"
            @page-change="onPageChange"
            @sort-change="onSortChange"
            @column-filter="onColumnFilter"
            @per-page-change="onPerPageChange"
            :pagination-options="paginationOptions"
            :select-options="{
              enabled: true,
              selectOnCheckboxOnly: true,
              disableSelectInfo: true,
            }"
            ><template #table-row="props">
              <span v-if="props.column.field == 'download'">
                <button
                  class="btn btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#downloadSingleDipModal"
                  style="width: 100px"
                >
                  Download
                </button>
                <!-- <button
                  class="btn btn-danger"
                  style="width: 90px"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteSingleDipModal"
                >
                  Delete
                </button> -->
              </span>
            </template>
            <template #table-actions-bottom>
              <pagination-records
                :pages="serverParams.page"
                :per-page="serverParams.perPage"
                :total="DipStore.totalRecords"
              />
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
  <manage-dips-modal
    :checked-data="checkedData"
    :selected-package-id="selectedPackageId"
    :selected-transfer-id="selectedTransferId"
    :selected-security-grading="selectedSecurityGrading"
  />
</template>

<script setup lang="ts">
import SearchDips from "@/components/DownloadDips/SearchDips.vue";
import ManageDipsModal from "@/components/Modal/ManageDipsModal.vue";
import PaginationRecords from "@/components/Pagination/PaginationRecords.vue";
import { useDIPStore } from "@/stores/dip";
import { useAsyncState } from "@vueuse/core";
import moment from "moment";
import { ref, watch } from "vue";

const DipStore = useDIPStore();
const selectedPackageId = ref("");
const selectedTransferId = ref("");
const selectedSecurityGrading = ref("");
const tableKey = ref(0);
const isLoading = ref(false);
const paginationOptions = ref({
  enabled: true,
  mode: "pages",
  position: "bottom",
  perPageDropdown: [20, 30, 50],
  dropdownAllowAll: true,
});

watch(
  () => DipStore.loading,
  (updateLoading) => (isLoading.value = updateLoading)
);

const currentDip: any = ref([]);

watch(
  () => DipStore.currentDip,
  (updateDip) => {
    currentDip.value = updateDip;
  }
);

const columns = [
  {
    label: "Transfer Batch No.",
    field: "transferBatchNumber",
  },
  {
    label: "Transferring Agency",
    field: "transferringAgency",
  },
  {
    label: "Transfer Date",
    field: "transferDate",
    formatFn: function (value: any) {
      if (value == null) {
        return "-";
      } else {
        return moment(new Date(value)).format("DD MMMM yyyy");
      }
    },
  },
  {
    label: "Security Grading",
    field: "securityGrading",
  },
  {
    label: "Sensitivity Classification",
    field: "sensitivityClassification",
  },
  {
    label: "DIP UUID",
    field: "id",
  },
  {
    label: "Transfer Not Scheduled",
    field: "id",
    formatFn: function (value) {
      if (value == null || value == "") return "NO";
      else return "YES";
    },
  },
  {
    field: "download",
    width: "100px",
    sortable: false,
  },
];

const serverParams = ref({
  columnFilters: [
    {
      fieldName: "transfer_number",
      filterText: DipStore.currentFilters[0].filterText,
    },
    {
      fieldName: "transferring_agency",
      filterText: DipStore.currentFilters[1].filterText,
    },
    {
      fieldName: "transfer_date",
      filterText: DipStore.currentFilters[2].filterText,
    },
    {
      fieldName: "security_grading",
      filterText: DipStore.currentFilters[3].filterText,
    },
    {
      fieldName: "sensivity_classification",
      filterText: DipStore.currentFilters[4].filterText,
    },
    {
      fieldName: "dip_uuid",
      filterText: DipStore.currentFilters[5].filterText,
    },
  ],
  sort: { field: "id", type: "desc" },
  page: DipStore.currentPage,
  perPage: DipStore.currentPerPage,
});

const checkedData: any = ref([]);
const buttonDisabled = ref(true);

const selectionChanged = (params) => {
  checkedData.value = [];
  buttonDisabled.value = true;
  for (let i = 0; i < params.selectedRows.length; i++) {
    checkedData.value.push({
      transferId: params.selectedRows[i].transferId,
      packageId: params.selectedRows[i].id,
      securityGrading: params.selectedRows[i].securityGrading,
    });
    buttonDisabled.value = false;
  }
};

const onRowClick = (params) => {
  selectedPackageId.value = params.row.id;
  selectedTransferId.value = params.row.transferId;
  selectedSecurityGrading.value = params.row.securityGrading;
  // console.log("selectedPackageId: ", selectedPackageId.value);
  // console.log("selectedTransferId: ", selectedTransferId.value);
};

const updateParams = (newProps: any) => {
  serverParams.value = Object.assign({}, serverParams.value, newProps);
};

const onPageChange = (params) => {
  //--START --use for showing xx-xx  of xxx records
  updateParams({
    perPage: params.currentPerPage,
    page: params.currentPage,
    currentContentId: 0,
  });
  //--END--
};

const onPerPageChange = (params) => {
  updateParams({
    perPage: params.currentPerPage,
    page: 1,
    currentContentId: 0,
  });
};

const onSortChange = (params) => {
  updateParams({
    page: 1,
  });
};

const forceRerender = () => {
  tableKey.value += 1;
};

const onColumnFilter = (params) => {
  DipStore.currentDip = [];
  forceRerender();
  updateParams({
    sort: { type: "desc", field: "id" },
    page: 1,
    currentContentId: 0,
  });
  execute();
};

const { execute } = useAsyncState(() => {
  return DipStore.fetchDip(serverParams.value.columnFilters as Array<object>);
}, null);

const listenTransferNumber = (inputParams) => {
  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transfer_number"
        ? { ...obj, filterText: inputParams.transferNo }
        : obj
  );

  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transferring_agency"
        ? { ...obj, filterText: inputParams.transferAgency }
        : obj
  );

  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "transfer_date"
        ? { ...obj, filterText: inputParams.transferDate }
        : obj
  );

  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "security_grading"
        ? { ...obj, filterText: inputParams.securityGrading }
        : obj
  );

  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "sensivity_classification"
        ? { ...obj, filterText: inputParams.sensitivityClassification }
        : obj
  );

  serverParams.value.columnFilters = serverParams.value.columnFilters.map(
    (obj) =>
      obj.fieldName === "dip_uuid"
        ? { ...obj, filterText: inputParams.uuid }
        : obj
  );

  onColumnFilter(serverParams);
};
</script>

<style scoped>
.vue-table {
  position: relative;
  padding-bottom: 20px;
}
.btn-actions {
  float: right;
  margin: 10px;
}
</style>
